import axios from "axios";
import { shopifyServiceBaseUrl } from "../../core/config";
import validateRequest from "./validateRequest";

export const get = async ({ endpoint, token, params = {}, query = {} }) => {
  const { isValid, errorMessage } = validateRequest(endpoint);

  if (!isValid) {
    throw new Error(errorMessage);
  }

  const endpointWithQuery = query ? `${endpoint}/${query}` : endpoint;

  const response = await axios.get(endpointWithQuery, {
    baseURL: `${shopifyServiceBaseUrl}`,
    params,
    ...(token
      ? {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      : {}),
  });

  return response;
};

export default get;
